import React, { useRef, useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './ServiceSection.css';
import img1 from '../../Assets/Services/Background.webp';
import img2 from '../../Assets/Services/Background-1.webp'
import img3 from '../../Assets/Services/Background-2.webp';
import img4 from '../../Assets/Services/Background-3.webp';

const services = [
  {
    title: "Automobile Logistics",
    desc: "Specialised car carrier solutions for the safe and efficient transportation of passenger vehicles for leading OEMs across India.",
    img: img1,
  },
  {
    title: "Chassis & Commercial Transport",
    desc: "Dedicated carriers designed to transport trucks, buses, tractors, and chassis, including compliant scrap vehicle movement.",
    img: img2,
  },
  {
    title: "ODC & Heavy Cargo Transport",
    desc: "Engineered logistics solutions for over-dimensional and heavy cargo, including earth movers and industrial equipment.",
    img: img3,
  },
  {
    title: "Mining & Surface Transport",
    desc: "Tailor-made mining and surface transport services designed to support large-scale industrial and mining operations.",
    img: img4,
  }
];

const ServiceSection = () => {
  const scrollRef = useRef(null);
  const ghostRef = useRef(null);
  const [translateX, setTranslateX] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (!ghostRef.current || !scrollRef.current) return;

      const stickyOffset = ghostRef.current.offsetTop;
      const stickyHeight = ghostRef.current.offsetHeight;
      const windowHeight = window.innerHeight;
      const scrollY = window.scrollY;

      const scrollDistance = scrollY - stickyOffset;
      const maxScroll = stickyHeight - windowHeight;
      let progress = scrollDistance / maxScroll;

      progress = Math.max(0, Math.min(1, progress));

      const trackWidth = scrollRef.current.scrollWidth;
      const viewWidth = window.innerWidth;

      // Calculate total travel distance
      // We subtract viewWidth so the last card stops at the right edge
      const moveAmount = progress * (trackWidth - viewWidth + 40);

      setTranslateX(-moveAmount);
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll); // Recalculate on resize
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  return (
    <div className="service-scroll-wrapper" ref={ghostRef}>
      <div className="sticky-container">
        <Container fluid className="ps-lg-5 ps-3">
          <div className="header-box py-4" style={{ textAlign: 'start', marginTop: "2%" }}>
            <span className="text-uppercase text-danger fw-bold letter-spacing-2">Our Services</span>
            <Row className="mt-2">
              <Col lg={6} md={8}>
                <h2 className="service-main-title fw-bold text-dark">
                  Specialised Logistics Services <br className="d-none d-md-block" /> Built for Reliability and Scale
                </h2>
              </Col>
              <Col lg={5} className="ms-auto d-none d-lg-block">
                <p className="text-muted">
                  Our services are designed to meet the demanding requirements of automobile manufacturers and industrial clients.
                </p>
              </Col>
            </Row>
          </div>

          <div
            className="horizontal-track mb-5"
            ref={scrollRef}
            style={{ transform: `translateX(${translateX}px)` }}
          >
            {services.map((ser, i) => (
              <div key={i} className="service-card">
                {/* CORRECTED LINE BELOW: Using template literals for the URL */}
                <div
                  className="card-inner"
                  style={{
                    backgroundImage: `url(${ser.img})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat'
                  }}
                >
                  <div className="card-overlay">
                    <div className="card-content p-4">
                      <h3 className="text-white h4 mb-2">{ser.title}</h3>
                      <p className="text-light small mb-0">{ser.desc}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </div>
    </div>
  );
};

export default ServiceSection;

